<template>
  <div :class="['slider', sliderType, { open: sliderOpen }]">
    <div class="header">
      <button class="close-btn" @click="closeSlider()">×</button>
    </div>
    
    <!-- Email Form -->
    <form v-if="emailFields" @submit.prevent="handleSubmit" class="column-form">
      <div class="form-group" v-for="(field, index) in emailFields" :key="index">
        <label :for="field.field">{{ field.question }}</label>
        <div v-if="field.field === 'textarea'" class="textarea-background">
          <textarea
            :id="field.field"
            :placeholder="field.example"
            v-model="emailFields[index].suggestion"
            @input="adjustHeight($event)"
          ></textarea>
        </div>
        <input
          v-if="field.field === 'input'"
          :id="field.field"
          type="text"
          :placeholder="field.example"
          v-model="emailFields[index].suggestion"
          class="form-input"
        />
      </div>
      <button type="submit" @click.prevent="sendEmail()" class="primary email-button">
        Email
      </button>
    </form>

    <!-- Prelim Questions Form -->
    <form
      v-if="prelimQuestions && !googleDocsUrl"
      @submit.prevent="handleSubmit"
      class="column-form"
    >
      <div class="form-group" v-for="(field, index) in prelimQuestions" :key="index">
        <label :for="field.field">{{ field.question }}</label>
        <div v-if="field.fieldType === 'textarea'" class="textarea-background">
          <textarea
            :placeholder="field.answer"
            v-model="prelimQuestions[index].answer"
            @input="adjustHeight($event)"
          ></textarea>
        </div>
        <input
          v-if="field.fieldType === 'input'"
          type="text"
          :placeholder="field.answer"
          v-model="prelimQuestions[index].answer"
          class="form-input"
        />
      </div>
      <button type="submit" @click.prevent="createDocClicked(prelimQuestions)" class="primary email-button">
        Create Doc
      </button>
    </form>

    <!-- Google Docs Iframe -->
    <div v-if="googleDocsUrl" class="docs-iframe-div">
      <iframe id="doc-frame" class="w-100 h-100" :src="googleDocsUrl"></iframe>
    </div>

    <!-- Conversation (Chat bubbles) -->
    <div v-if="taskConversation">
      <SliderConversation />
    </div>

    <!-- Loading Fallback -->
    <LoadingSpinnerIcon v-if="!emailFields && !googleDocsUrl && !prelimQuestions && !taskConversation" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import actionsService from '@/services/actionsService.js'
import LoadingSpinnerIcon from '@/components/LoadingSpinner.vue'
import SliderConversation from '@/components/SliderConversation.vue'

export default {
  name: 'TaskSlider',
  components: {
    LoadingSpinnerIcon,
    SliderConversation
  },
  computed: {
    ...mapGetters([
      'emailFields',
      'sliderOpen',
      'googleDocsUrl',
      'prelimQuestions',
      'taskConversation'
    ]),
    // Use class "wide" if googleDocsUrl or taskConversation exist; otherwise, default.
    sliderType() {
      return (this.googleDocsUrl || this.taskConversation) ? 'wide' : 'default'
    }
  },
  methods: {
    async sendEmail() {
      await actionsService.sendEmail(this.emailFields)
    },
    createDocClicked(prelimQuestions) {
      this.$store.dispatch('performAction', { prelimQuestions })
    },
    closeSlider() {
      this.$store.dispatch('setSliderState', false)
    },
    adjustHeight(event) {
      const textarea = event.target
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    },
    handleSubmit() {
      // Your submit logic if needed
    }
  },
  mounted() {
    const textareas = this.$el.querySelectorAll('textarea')
    textareas.forEach((textarea) => {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    })
  }
}
</script>

<style scoped>
/* Base Slider Styles (Desktop) */
.slider {
  position: fixed;
  top: 0;
  right: -100%;
  height: 100vh;
  background-color: var(--Theme-Color-Secondary-Black);
  box-shadow: -4px 0 6px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  transition: right 0.3s ease;
  z-index: 1000;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 1rem;
  width: 700px; /* Default width */
}
.slider.wide {
  width: 1500px; /* Wide version */
}
.slider.open {
  right: 0;
}

/* Header (for close button) */
.header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

/* Form Layout */
.column-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Button & Input Styles */
.email-button {
  width: 8rem;
  margin-left: auto;
}
.textarea-background {
  background-color: var(--Border-Color-Primary);
  border: 1px solid var(--Border-Color-Primary);
  border-radius: 15px;
  padding: 15px;
  display: flex;
}
.form-input {
  background-color: var(--Border-Color-Primary);
  border: 1px solid var(--Border-Color-Primary);
  box-sizing: border-box;
}

/* Docs Iframe */
.docs-iframe-div {
  height: 100%;
}

/* Close Button */
.close-btn {
  font-size: 24px;
  color: var(--text-light);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 10px;
}
.close-btn:hover {
  color: var(--danger-color);
}

/* Desktop fixed widths for other elements (if needed) */
#accordion {
  width: 48rem;
}

/* MOBILE OVERRIDE using a media query */
@media (max-width: 768px) {
  .slider,
  .slider.wide {
    width: 100% !important;
    height: 100vh;
    top: 0;
  }
  /* Adjust container spacing on mobile */
  .slider {
    padding: 0.5rem;
  }
  .header {
    margin-bottom: 0.5rem;
  }
  /* Allow forms and accordion to use full width */
  #accordion {
    width: 100% !important;
  }
  /* Optional: adjust form-group spacing if needed */
  .form-group {
    gap: 0.5rem;
  }
  .message-content{
    max-width: 100% !important;
  }
}
</style>
